import {
    CardContent,
    CardHeader,
    CardMedia,
    Grid,
    Typography,
} from "@mui/material";

import ResponsiveAppBar from "../../components/AppBar";
import CaseStudyBackground from "../../components/caseStudies/caseStudyBackground";
import CaseStudyLanding from "../../components/caseStudies/caseStudyLanding";
import CaseStudyVision from "../../components/caseStudies/caseStudyVision";
import Box from "@mui/material/Box";




import ImageSlider from "../../components/ImageSlider";
import Button from "@mui/material/Button";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Carousel from "react-material-ui-carousel";
import { ImageItem } from "../../components/ImageCarousel";

import CaseStudySummary from "../../components/caseStudies/caseStudySummary";
import { HashLink } from "react-router-hash-link";
import ImageCard from "../../components/ImageCard";

export default function CurbToKitchen() {
    const carouselItems = [
      {
        name: "Typical configuration",
        img: "https://dl.dropboxusercontent.com/scl/fi/3ynswutdxhpce9othsazp/Curbs-01.jpg?rlkey=5gms4f7g3nmn9a2an71pf8evt&st=5to08c7v&dl=0",
      },
      {
        name: "Optimized configuration",
        img: "https://dl.dropboxusercontent.com/scl/fi/dc06fzuxs1a0zx1adpnj8/Curbs-02.jpg?rlkey=tombxmraykntyhxsngti2gekm&st=mpr2gloz&dl=0",
      },
  ];
  
  const luCarouselItems = [
    {
      name: "",
      img: "https://dl.dropboxusercontent.com/scl/fi/d4dbxbly730v1v2upe76w/Step1.jpg?rlkey=xm02zr3jayvj50la3xju28h1i&st=wjsd6vn2&dl=0",
    },
    {
      name: "",
      img: "https://dl.dropboxusercontent.com/scl/fi/7yjcv5u5nlh9pvy09wsgr/Step2.jpg?rlkey=jx3b51zpljlbceunu3867rf2g&st=kd6k0ugb&dl=0",
    },
    {
      name: "",
      img: "https://dl.dropboxusercontent.com/scl/fi/sc1sdxhfq5io8g3l4jg5d/Step3.jpg?rlkey=82t92uv8e54dz057ga7jskjbt&st=ajxw5xoj&dl=0",
    },
    {
      name: "",
      img: "https://dl.dropboxusercontent.com/scl/fi/jkyux5ykgsmsafwwb3hvs/Step4.jpg?rlkey=vkmh9wlo0ljjffgqc5348a7hr&st=xv7d6k67&dl=0",
    },
    {
      name: "",
      img: "https://dl.dropboxusercontent.com/scl/fi/h2fcbflww15jd1i1p0jgu/Step5.jpg?rlkey=zgvdzm4ks4lk35d7qpet5fqy5&st=xptf7bg9&dl=0",
    },
  ];
    return (
      <div id="c2k-main">
        <ResponsiveAppBar />
        <CaseStudyLanding
          image={
            "https://dl.dropboxusercontent.com/scl/fi/4e3g0v941w0bq24no2jf6/Drone-Delivery-cover.png?rlkey=w5fdpe41r2go9nd1un94imvzo&st=w8gs6gut&dl=0"
          }
          title="CURB-TO-KITCHEN"
          subtitle="Beyond The Last Mile"
          body={[
            `Curb-to-Kitchen (C2K) explores one of the great unsolved challenges of the
            autonomous mobility transition: what happens after drop-off. As AVs, delivery bots,
            and low-speed micro-mobility systems reshape how people move, little attention has
            been paid to the last-meter connection between curb and destination—especially for
            mobility-challenged users. This research initiative, developed through real-world
            partnerships and supported by the Toyota Mobility Foundation, investigates how land
            use planning, building code, and urban design must evolve to accommodate this
            missing link.

            The project explores everything from accessible micro-mobility corridors and
            front-door vehicle loading zones to future-ready parcel delivery networks, modeled
            using the NOGAS Toolkit. C2K reframes the suburban landscape as a multi-modal
            ecosystem where robotic logistics, shared mobility, and aging-in-place strategies
            converge—bridging the last meter between the street and the home.`,
          ]}
        />
        <CaseStudyBackground
          title="WHY THIS MATTERS"
          subtitle="Rethinking Suburban Access"
          image={
            "https://dl.dropboxusercontent.com/scl/fi/1mvqwbsu79e6qok1wx6r7/EV-stop-02.jpg?rlkey=5l51y6zkrovxdhmgss6ci53az&st=px9a0d3b&dl=0"
          }
          body={[
            `Most accessibility codes in the U.S. were written for public
            facilities, not for homes, sidewalks, or the everyday
            experience of disabled or aging residents. In sprawling
            suburban contexts, this has created enormous physical and
            logistical barriers to independence, health, affordability and
            dignity.

            By envisioning seamless movement between curb and
            kitchen—via bots, drones, AVs, and shared services—C2K
            supports the “aging in place” by increasing access to basic
            services, recreation, and social infrastructure. It also
            recognizes that the future of access isn’t just about
            vehicles; it’s about rethinking buildings, setbacks, delivery
            zones, and thresholds to create more permeable
            environments that function for all users—from walkers to
            bots—turning streetscapes`,
          ]}
          stats={[
            {
              pct: ">50%",
              text: "Population Lives in Auto-Dependent Suburbs",
            },
            {
              pct: "1 in 4",
              text: "Adults Live With a Disability",
            },
            {
              pct: "40%",
              text: "Adults +65 Experience Mobility Issues",
            },
          ]}
        />
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          sx={{ width: "100vw", height: "100%", overflowY: "hidden" }}
        >
          <img
          src="https://dl.dropboxusercontent.com/scl/fi/7ydyl67nnqtz6liqeo1lw/C2K.jpg?rlkey=stiusitaj4cyy1haq45s7eh0h&dl=0oxusercontent.com/scl/fi/85x1iljxz9ixcmllvwdrg/L2_Micro6_cropped.jpg?rlkey=q5aji0vl46ppb705ndhzxnf2r&dl=0"
          alt="Curb to Kitchen"
          style={{ width: "80vw", height: "80%", objectFit: "cover" }}
          />{" "}
        </Grid>{" "}
        <CaseStudyVision
          title="WHAT IS CURB-TO-KITCHEN?"
          subtitle="Designing Multimodal Suburbs for Everyday Mobility"
          body={[
            `C2K refers to the last-meter interface between mobility
            systems and the home or destination—between where one is
            dropped off and where one needs to go. In legacy street and
            land use systems, this space is fragmented and often
            impassable to those with mobility challenges. In a future
            shaped by autonomous transportation systems, this interface
            must be radically rethought.
            

            C2K challenges conventional frameworks that end access at
            the driveway or sidewalk. C2K strategies demonstrate how
            spatial changes—like widened setbacks, shared drop-off
            areas, and AV-friendly site plans—can be layered into existing
            and new communities. Early outputs of the project include new
            block typologies, scenario-based design proposals, and code
            recommendations for integrating AV-ready, universally
            accessible features into mixed-use suburban districts`,
          ]}
          icons={[
            {
              img: "https://nogas-swar.s3.amazonaws.com/img/4_Case+Study+02_+Preparing+for+Future+Growth/3_Vision/Smart+Density.png",
              alt: "",
              label: "Smart Density",
            },
            {
              img: "https://nogas-swar.s3.amazonaws.com/img/4_Case+Study+02_+Preparing+for+Future+Growth/3_Vision/Vehicle+Usage.png",
              alt: "",
              label: "Reduced Vehicle Usage",
            },
            {
              img: "https://nogas-swar.s3.amazonaws.com/img/4_Case+Study+02_+Preparing+for+Future+Growth/3_Vision/Better+Envir-performance.png",
              alt: "",
              label: "Better Environmental Performance",
            },
          ]}
        />
      {/* ---Image Slider --- */}
      <Grid
        container
        direction="column"
        alignItems="left"
        justifyContent="left"
        sx={{
          backgroundColor: "#fff",
          px: { xs: "auto", md: "10vw" },
          my: { xs: "2em", md: "4em" },
          width: "100%",
        }}
      >
        {/* Title */}
        <Box sx={{ width: "100%", mb: { xs: 2, md: 3 }, textAlign: "left" }}>
          <Typography
            variant="sectionTitle"
                            sx={(t) => ({
                              [t.breakpoints.down("sm")]: {
                                fontSize: "1.6rem",
                                lineHeight: 1.2,
                                },
                              })}
          >
            ReImagining Delivery
          </Typography>
        </Box>

        {/* Body */}
        <Box sx={{ width: "100%", mb: { xs: 2, md: 3 }, textAlign: "left" }}>
          <Typography
            variant="bodyBlack"
                          sx={(t) => ({
                            [t.breakpoints.down("sm")]: {
                              fontSize: "1rem",
                              lineHeight: 1.2,
                              },
                            })}
          >
            Envisioning a future where autonomous delivery systems become integrated into the spatial fabric of suburban living. Here packages arrive at the delivery hub where users can schedule a delivery based on availability of robots or drones. Users can also pick up the packages by themselves at the hub. The optimal route for delivery robots will be assigned based on the principle of minimizing total delivery distance. 
          </Typography>
        </Box>
          <img
          src="https://dl.dropboxusercontent.com/scl/fi/85x1iljxz9ixcmllvwdrg/L2_Micro6_cropped.jpg?rlkey=q5aji0vl46ppb705ndhzxnf2r&dl=0"
          alt="Curb to Kitchen"
          style={{ width: "80vw", height: "80%", objectFit: "cover", justifyContent: "left" }}
          />{" "}

      </Grid>
        {/* <div> custom stuff </div> */}
        <Grid container direction="column" sx={{ marginTop: "7vh" }}>
          <Grid item>
            <Grid container direction="row">
              <Grid item xs={0} md={6}>
                {" "}
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
                sx={{ padding: { xs: "2em", md: "7em" }, textAlign: "left" }}
              >
                <Typography variant="sectionTitle"
                            sx={(t) => ({
                              [t.breakpoints.down("sm")]: {
                                fontSize: "1.6rem",
                                lineHeight: 1.2,
                                },
                              })}
                >
                  {" "}
                  FROM NEIGHBORHOODS TO NETWORKS{" "}
                </Typography>
                <br></br>
                <Typography variant="sectionSubtitle"
                            sx={(t) => ({
                            [t.breakpoints.down("sm")]: {
                              fontSize: "1.2rem",
                              lineHeight: 1.2,
                              },
                            })}
                >
                  A Framework For Micromobility
                </Typography>
                <hr color="EC008C"></hr>
                <Typography variant="bodyBlack"
                            sx={(t) => ({
                            [t.breakpoints.down("sm")]: {
                              fontSize: "1rem",
                              lineHeight: 1.2,
                              },
                            })}
                >
                One of C2K’s key contributions is its rethinking of parcel delivery systems in
                the context of autonomous mobility. As AV technology matures, the project
                anticipates a shift away from conventional vehicle drop-off toward hybrid and
                fully autonomous delivery networks that include drones, robotic carts, and
                flexible delivery hubs.
                <br></br>
                <br></br>
                In AD1 scenarios, delivery vehicles still reach individual homes—but with
                integrated support from localized bots or drone dispatch centers. In AD2,
                robotic delivery fleets serve entire neighborhoods from shared nodes,
                reducing vehicular delivery distances by up to 26%, while robotic delivery
                becomes 63% more efficient. The C2K team modeled multi-modal delivery
                routes, adaptable loading zones, and last-meter fulfillment infrastructure—all
                designed to minimize travel distances, reduce energy use, and support
                direct-to-doorstep and in-home delivery for all users, regardless of mobility
                level.
                </Typography>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            container
            justifyContent="center"
            alignContent="center"
            direction="column"
            sx={{
              paddingLeft: { xs: "2em", md: "25%" },
              paddingRight: { xs: "2em", md: "25%" },
              marginBottom: "1em",
            }}
          >
            <Grid item xs={12} md={6} elevation={5}>
              <Typography variant="sectionSubtitle"
                          sx={(t) => ({
                            [t.breakpoints.down("sm")]: {
                              fontSize: "1.2rem",
                              lineHeight: 1.2,
                              },
                            })}
              >
                Generation Method
              </Typography>
              <Typography variant="body2"
                          sx={(t) => ({
                            [t.breakpoints.down("sm")]: {
                              fontSize: ".65rem",
                              lineHeight: 1.2,
                              padding: ".5rem 4rem",
                              justifyContent: "right",
                              },
                            })}
              >
              Click through the diagrams below to explore the generational method
              for creating neighborhood-scale multi-modal networks.
              </Typography>
              <br></br>
            </Grid>
            <Grid item xs={12} md={6} elevation={5}>
              <Carousel
                navButtonsAlwaysVisible={false}
                sx={{ maxWidth: "100%", minHeight: "500px" }}
              >
                {luCarouselItems.map((img, i) => (
                  <ImageItem key={i} image={img.img} name={img.name} />
                ))}
              </Carousel>
            </Grid>{" "}
          </Grid>
          <Grid container direction="row">
            <Grid
              item
              xs={12}
              md={6}
              sx={{ padding: { xs: "2em", md: "7em" }, textAlign: "left" }}
            >
              <Typography variant="sectionTitle"
                          sx={(t) => ({
                            [t.breakpoints.down("sm")]: {
                              fontSize: "1.6rem",
                              lineHeight: 1.2,
                              },
                            })}
              >
                {" "}
                THE CURB, REIMAGINED{" "}
              </Typography>
              <br></br>
              <Typography variant="sectionSubtitle"
                          sx={(t) => ({
                            [t.breakpoints.down("sm")]: {
                              fontSize: "1.2rem",
                              lineHeight: 1.2,
                              },
                            })}
              >
                Design Recommendations For A More Connected Future
              </Typography>
              <hr color="EC008C"></hr>
              <Typography variant="bodyBlack"
                          sx={(t) => ({
                            [t.breakpoints.down("sm")]: {
                              fontSize: "1rem",
                              lineHeight: 1.2,
                              },
                            })}
              >
              At the heart of C2K is a simple question: What does an accessible 
              autonomous future look like—at the scale of the curb? Today’s 
              accessibility codes were not written for AVs, delivery bots, or low-speed 
              shared mobility systems. Passenger loading zones, curb cuts, and 
              sidewalk interfaces need to be rethought from the ground up.
              <br></br>
              <br></br>
              C2K delivers design and code recommendations across land use 
              types—addressing conflicts between pedestrians, vehicles, and 
              delivery systems; proposing performance-based zoning for loading and 
              access; and reframing the curb as a social interface. The goal is not just 
              compliance, but design that proactively includes disabled, elderly, and 
              mobility-challenged users in the AV transition. A seamless 
              journey—from curb to kitchen—begins with reimagining standard 
              features like curbs, crosswalks, and set-backs as agents of improved 
              barrier-free movement.
              </Typography>
              <br></br>
              <br></br>
            </Grid>
            <Grid item xs={0} md={6}>
              {" "}
            </Grid>
          </Grid>
          <Grid
            container
            justifyContent="center"
            alignContent="center"
            direction="column"
            sx={{
              paddingLeft: { xs: "2em", md: "25%" },
              paddingRight: { xs: "2em", md: "25%" },
              marginBottom: "2em",
            }}
          >
            <Grid item xs={12} md={6} elevation={5}>
              <Typography variant="sectionSubtitle"
                        sx={(t) => ({
                            [t.breakpoints.down("sm")]: {
                              fontSize: "1.6rem",
                              lineHeight: 1.2,
                              },
                            })}
              >
                Redesigning the Curb
              </Typography>
              <Typography variant="body2"
                        sx={(t) => ({
                            [t.breakpoints.down("sm")]: {
                              fontSize: ".65rem",
                              lineHeight: 1.2,
                              padding: ".5rem 4rem",
                              justifyContent: "right",
                              },
                            })}
              >
                Click through the two scenarios to see how existing ada curb cuts can be retrofitted to incorporate a range of micro-mobility elements.
              </Typography>
              
            </Grid>
            <Grid item xs={12} md={6} elevation={5}>
              <Carousel
                navButtonsAlwaysVisible={false}
                sx={{ maxWidth: "100%", minHeight: "500px" }}
              >
                {carouselItems.map((img, i) => (
                  <ImageItem key={i} image={img.img} name={img.name} />
                ))}
              </Carousel>
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
}